/* ============================================================
   ILEV - ANIVERSARIO ANTICASPA
   CONFIGURACION del carrito: textos, productos y REGLAS.

   ⭐ ESTE es el archivo donde se cambian numeros y textos.

   ⚠ IMPORTANTE: los nombres de las claves los define
   component-shipping-notice.js (v10). Si se renombran, el
   carrito lanza un error y deja de pintar la barra Y la venta
   cruzada. Los hitos van con: monto / n / i / falta

   ⚠ 07-sep: el umbral de envio gratis baja de $40.000 a $39.000.
   Motivo: el DUO con el 20% de FLASH queda en $39.840 y se
   quedaba a $160 del envio gratis. El umbral vive en TRES
   sitios de este archivo (umbral, hitos[0].monto y el sello
   trust) y ADEMAS en el descuento automatico de Shopify
   "Aniversario Anticaspa · Envio gratis". Si no coinciden, la
   barra promete algo que el checkout no cumple.
   ============================================================ */

window.ILEV_ACTIVO = true;

window.ILEV_IDS = {
  duo:     44077689536693,
  tonico:  42481091084469,
  bomba:   43620701995189,
  shampoo: 44971738235061
};

/* ============================================================
   REGLA DE VENTA CRUZADA
   Recibe `tiene(id)` para preguntar si algo ya esta en el carrito
   y devuelve los ids a sugerir, EN ORDEN.
   ============================================================ */
window.ILEV_REGLA = function (tiene, ID) {
  var duo = tiene(ID.duo);
  var ton = tiene(ID.tonico);
  var bom = tiene(ID.bomba);
  var sha = tiene(ID.shampoo);

  var out = [];

  if (duo || (ton && bom)) {
    /* ya tiene la rutina completa: no se le ofrece nada de eso */
  } else if (ton) {
    out.push(ID.bomba, ID.duo);
  } else if (bom) {
    out.push(ID.tonico, ID.duo);
  } else {
    out.push(ID.duo, ID.tonico, ID.bomba);
  }

  if (!sha) out.push(ID.shampoo);

  return out;
};

window.ILEV_CFG = {
  /* --- umbral de envio gratis --- */
  umbral: 39000,

  /* ============================================================
     LAS METAS DE LA BARRA  (las dibuja component-shipping-notice.js)
     Claves obligatorias: monto · n · i · falta
     Iconos disponibles: 'truck', 'gift'

     ⚠ El hito del Shampoo Anticaída lo cumple una app (EasyGift),
     no un descuento automatico de Shopify.
     ============================================================ */
  hitos: [
    {
      monto: 39000,
      n: 'Envío gratis',
      i: 'truck',
      falta: 'Te faltan <strong>{x}</strong> para conseguir el envío gratuito!'
    },
    {
      monto: 110000,
      n: 'Shampoo Anticaída gratis',
      i: 'gift',
      falta: 'Te faltan <strong>{x}</strong> para llevarte el <strong>Shampoo Anticaída</strong> de regalo!'
    }
  ],

  /* --- el regalo --- */
  regaloProductId: 10572843647157,
  regaloVariantId: 53104403873973,
  regalosExcluidos: [53104403873973],
  maxRegalo: 1,
  msgTope: 'El regalo de lanzamiento es uno por persona, para que alcance para todos.',

  /* --- costo del despacho, para los textos de los popups --- */
  despacho: 4500,

  /* --- titulos de la venta cruzada --- */
  tituloConDato: 'El 86% de los clientes también se llevó:',
  tituloGenerico: 'Completa tu rutina',

  /* --- textos de la barra --- */
  txtFalta:   'Te faltan <strong>{x}</strong> para conseguir el envío gratuito!',
  txtCasi:    'Estás a <strong>{x}</strong> de conseguir el envío gratuito!',
  txtVacio:   'Suma tu rutina y consigue el <strong>envío gratuito</strong>',
  txtLogrado: '¡Conseguiste el <strong>envío gratuito</strong>!',
  txtTodo:    '¡Desbloqueaste todo: <strong>envío gratis + Shampoo Anticaída</strong> de regalo!',

  txtTarjeta: '+ Envío gratis',
  minResenas: 5,

  /* ============================================================
     TEXTOS DE LOS DOS POPUPS
     Los muestra assets/ilev-carrito-fix.js (en todo el sitio)
     ============================================================ */
  modal: {
    imagen: 'https://cdn.shopify.com/s/files/1/0619/8296/5941/files/anticaspa30g.png?v=1788731462&width=240',

    /* --- popup 1: cuando el regalo ENTRA al carrito --- */
    okKicker:  'Tu regalo quedó adentro',
    okTitulo:  '¡Listo! Es tuyo 🎁',
    okTexto:   'Shampoo Anticaspa Viajero 30 g. Te lo regalamos por nuestro aniversario.',
    okEnvio:   'Lo único que pagas es el despacho: <strong>{envio}</strong> a cualquier parte de Chile.',

    /* ============================================================
       EL BLOQUE DESTACADO DEL POPUP

       Con okMetaMensaje puesto -> modo AVISO: frase fija.
       Si se BORRA okMetaMensaje -> modo CIFRA: muestra en grande
       cuanto le falta para el envio gratis (usa okMetaKicker
       y okMetaTexto).
       {umbral} se reemplaza solo por el monto de arriba.
       ============================================================ */
    okMetaKicker:  'Aviso de utilidad pública',
    okMetaMensaje: 'Aprovecha el <strong>envío gratis</strong> en todos los pedidos sobre <strong>{umbral}</strong>',

    /* textos del modo CIFRA (hoy sin uso) */
    okMetaTexto:   'y te ahorras los <strong>{envio}</strong> del despacho',

    /* cuando ya consiguio el envio gratis */
    okMetaListo:      '¡Tienes envío gratis!',
    okMetaListoTexto: 'Ya no pagas despacho',

    /* textos del diseño anterior (META_DESTACADA = false) */
    okCruceFalta:  'Te faltan <strong>{falta}</strong> para que el envío también te salga gratis',
    okCruceListo:  '¡Ya tienes el <strong>envío gratis</strong>! No pagas nada de despacho',

    okCruceTitulo: 'Aprovecha el mismo despacho',

    /* BOTON AZUL: el que sube el ticket. Lleva a la pagina de rutinas. */
    okBtnSeguir:    'Añadir rutina anticaída con envío gratis',
    okBtnSeguirUrl: '/pages/tu-objetivo',
    /* BOTON BLANCO */
    okBtnCarrito:   'Ir a mi carrito',

    /* --- popup 2: cuando intenta llevar una segunda --- */
    topeKicker: 'Solo uno por persona',
    topeTitulo: 'Ya tienes tu regalo 🎁',
    topeTexto:  'El regalo de lanzamiento es uno por persona, para que alcance para todos.',
    topeBtn:    'Entendido',
    topeBtnCarrito: 'Ver mi carrito'
  },

  /* --- sellos bajo el boton de pago --- */
  trust: [
    { i: 'truck', t: 'Envío gratis $39.000' },
    { i: 'shield', t: 'Garantía de 90 días' },
    { i: 'lock', t: 'Pago 100% seguro' }
  ],

  /* --- productos de la rutina (r = rating Loox, nr = n de resenas) --- */
  productos: {
    44077689536693: { n: 'DUO Anticaida - Tonico + Bomba', p: 49800, r: 4.7, nr: 127, img: 'ilevroutine-duo-portada-1_200x.jpg?v=1788611404' },
    42481091084469: { n: 'Tonico Anticaida',               p: 23900, r: 4.5, nr: 446, img: 'ilevroutine-tonico-portada-1_200x.jpg?v=1783023331' },
    43620701995189: { n: 'Bomba Nutricional',              p: 25900, r: 4.9, nr: 88,  img: 'ilevroutine-bomba-portada-1_200x.jpg?v=1783023237' },
    44971738235061: { n: 'Shampoo Anticaida en barra 70 g',p: 16990, r: 4.8, nr: 10,  img: 'ilevroutine-shampoo-portada-1_200x.jpg?v=1783023012' }
  },

  /* --- se muestran despues de los de la rutina --- */
  extras: [
    { id: 45474721726645, n: 'Tonico de Barba',     p: 28900, r: 4.0, nr: 1,  img: 'ilevroutine-barba-portada-1_200x.jpg?v=1783022884' },
    { id: 42480528785589, n: 'Serum Antiquiebre',   p: 20900, r: 4.9, nr: 14, img: 'ilevroutine-serum-portada-1_200x.jpg?v=1783022884' },
    { id: 53216576405685, n: 'Anticaspa 70 g (XL)', p: 17990, r: 0,   nr: 0,  img: '' }
  ]
};
